import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { authLogin, verifyAuthToken } from "../../services/authService";
import { setProfile } from "./profileSlice";
import { toast } from "react-toastify";
import { apiRequest } from "../../util/apiUtils";

const access_token = localStorage.getItem("auth_token");

const initialState = {
  session: { user: null, status: "loading", error: null },
  loginPending: false,
  loginError: null,
  loginData: null,
};

// Thunk for login
// export const login = createAsyncThunk(
//   "auth/admin-login",
//   async (
//     { redirect = false, type = "user", navigate, location, ...val },
//     { dispatch }
//   ) => {
//     const res = await authLogin({ ...val, type });
//     console.log(res, "authslice");
//     // if (res?.status === 200) {
//     //   if (res?.redirectionLink?.accept) {
//     //     if (res.forcePassword && type === "user") {
//     //       navigate("reset-password", {
//     //         state: { email: val?.email, forcePassword: res?.forcePassword },
//     //       });
//     //     } else {
//     //       navigate("accept-user");
//     //     }
//     //   } else {
//     //     const { accessToken, refreshToken, user } = res;
//     //     localStorage.setItem("auth_token", accessToken);
//     //     localStorage.setItem("refreshToken", refreshToken);

//     //     dispatch(setProfile({ ...user, access_token: accessToken }));
//     //     dispatch(
//     //       setSession({
//     //         user: { ...user, access_token: accessToken },
//     //         status: "authorized",
//     //         error: null,
//     //       })
//     //     );

//     //     const params = new URLSearchParams(location?.search);
//     //     const callback = params.get("callback");

//     //     if (callback) {
//     //       navigate(callback);
//     //     } else {
//     //       navigate(redirect || "/");
//     //     }
//     //   }
//     // }

//     if (res?.status === 200) {
//       const { accessToken, idToken } = res;

//       localStorage.setItem("auth_token", accessToken);

//       const userInfo = await verifyAuthToken(); // gets user profile

//       dispatch(setProfile({ ...userInfo?.data, access_token: accessToken }));
//       dispatch(
//         setSession({
//           user: { ...userInfo?.data, access_token: accessToken },
//           status: "authorized",
//           error: null,
//         })
//       );

//       navigate(redirect || "/");
//     } else {
//       console.log(res, "login error");
//       toast.error(res?.message || "Something went wrong");
//     }

//     return res;
//   }
// );

export const login = createAsyncThunk(
  "auth/admin-login", // Or change to "auth/login" if shared between user/admin
  async (
    { redirect = false, type = "user", navigate, location, ...val },
    { dispatch }
  ) => {
    try {
      const res = await authLogin({ ...val, type });

      if (res?.status !== 200) {
        toast.error(res?.message || res?.data?.message || "Auth0 login failed");
        return res;
      }

      const access_token = res?.data?.access_token || res?.data?.accessToken;
      const refresh_token = res?.data?.refresh_token;

      if (!access_token) {
        toast.error(res?.message || "No access token received");
        return res;
      }
      let userInfo = res?.data?.user || {};
      if (type === "user") {
        // Call backend to store/verify user
        const backendRes = await apiRequest("post", "/third-signin", {
          body: { access_token },
        });

        // Check for unverified email before proceeding
        if (backendRes?.data?.status === 403) {
          localStorage.removeItem("auth_token");
          localStorage.removeItem("refresh_token");
          toast.error(backendRes?.data?.message || "Email not verified.");
          return backendRes;
        }

        if (!backendRes?.data?.success) {
          toast.error(backendRes?.data?.message || "Backend user save failed");
          return backendRes;
        }
        userInfo = backendRes?.data?.user || userInfo;
      }
      // Save tokens
      localStorage.setItem("auth_token", access_token);
      localStorage.setItem("refresh_token", refresh_token);

      // const userInfo = backendRes?.data?.user || res?.data?.user || {};

      dispatch(setProfile({ ...userInfo, access_token }));
      dispatch(
        setSession({
          user: { ...userInfo, access_token },
          status: "authorized",
          error: null,
        })
      );

      navigate(redirect || "/");

      return res;
    } catch (err) {
      console.error("Login error", err);
      toast.error(
        err?.response?.data?.message || "Login error, please try again"
      );
      return { error: err };
    }
  }
);

// Thunk for verifying auth token
export const verifyAuth = createAsyncThunk(
  "auth/verifyAuth",
  async (_, { dispatch }) => {
    const res = await verifyAuthToken();
    const accessToken = localStorage.getItem("auth_token");

    if (res?.status === 200) {
      dispatch(setProfile({ ...res?.data, access_token: accessToken }));
      return {
        user: { ...res?.data, access_token: accessToken },
        status: "authorized",
        error: null,
      };
    } else if (res?.data?.invalidToken) {
      localStorage.removeItem("auth_token");
      localStorage.removeItem("refreshToken");
      dispatch(setProfile(null));
      return {
        user: null,
        status: "unauthorized",
        error: "Invalid token",
      };
    } else {
      dispatch(setProfile(null));
      return {
        user: null,
        status: "unauthorized",
        error: null,
      };
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setSession: (state, action) => {
      state.session = { ...state.session, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loginPending = true;
        state.loginError = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loginPending = false;
        state.loginData = action.payload;
      })
      .addCase(login.rejected, (state, action) => {
        state.loginPending = false;
        state.loginError = action.error.message;
      })
      .addCase(verifyAuth.fulfilled, (state, action) => {
        state.session = {
          user: action.payload.user,
          status: action.payload.status,
          error: action.payload.error,
        };
      });
  },
});

export const { setSession } = authSlice.actions;
export default authSlice.reducer;
